import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ButtonDownloadEInvoice from "../_common/buttonDownloadEInvoice";
import ButtonDownloadStandard from "../_common/buttonDownloadStandard";

const FooterCard = props => {
  const {
    documentId,
    filename,
    getDownload,
    handleClick,
    isEinvoice,
    subtitle,
    notesCount
  } = props;

  return (
    <div className="footer-card-container">
      <div className="footer-card-notes-container">
        {notesCount !== 0 && <div className="footer-card-notes-counter" >
          {parseInt(notesCount) > 100 ? "99+" : notesCount}
        </div>}
        <FontAwesomeIcon
          icon={["far", "comment-alt"]}
          className="footer-card-notes-icon"
        />
      </div>
      <div
        className="footer-card-eye"
        onClick={e => {
          handleClick(
            e, documentId, subtitle
          );
        }}
      >
        <FontAwesomeIcon
          icon={["far", "eye"]}
        />
      </div>
      {isEinvoice ? (
        <ButtonDownloadEInvoice
          documentId={documentId}
          filename={filename}
          getDownload={getDownload}
          isEinvoice={isEinvoice}
        />
      ) : (
        <ButtonDownloadStandard
          documentId={documentId}
          filename={filename}
          getDownload={getDownload}
        />
      )}
    </div>
  );
};

export default FooterCard;
